import {
  ActionSocial,
  ActionTheme,
  HDLogo,
  HeaderAction,
  HeaderDashboardContainer,
  HeaderDashboardWrapper,
  HeaderNavigation,
  NavigationHamburger,
  NavigationMobile,
  NavigationMobileItem,
  NavigationMobileMain,
  PriceToken,
} from "./styled";
import header_logo from "../../../assets/Header/logo.svg";
import { matchPath, NavLink, useLocation, useParams } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import iconSwap from "../../../assets/Dashboard/Header/icon-swap.svg";
import iconLauch from "../../../assets/Dashboard/Header/icon-lauch.svg";
import iconLiquidity from "../../../assets/Dashboard/Header/icon-liquidity.svg";
import iconStaking from "../../../assets/Dashboard/Header/icon-staking.svg";
import iconSwap_light from "../../../assets/Dashboard/Header/iconSwap_light.svg";
import iconLauch_light from "../../../assets/Dashboard/Header/iconLauch_light.svg";
import iconLiquidity_light from "../../../assets/Dashboard/Header/iconLiquidity_light.svg";
import iconStaking_light from "../../../assets/Dashboard/Header/iconStaking_light.svg";
import { Link } from "react-router-dom";
import ModalOverlay from "../../Common/ModalOverlay";
import WalletInfo from "../Wallet";
import { ContextProviderWrapper } from "../../Context";
import toast from "react-hot-toast";
import NotificationHead from "./Notification";
import { useDispatch } from "../../../store/store";
import {
  getActiveChain,
  getAggregators,
  getChains,
  getKIBPrice,
} from "../../../store/features/poolsSlice";
import { useSelector } from "react-redux";
import { AVAX_API } from "../../../services/api/indexV2";
import ConnectWallet from "./Connect";
import SwitchChain from "./Switch";

const HeaderDashboard = ({ chain }: any) => {
  const { pathname } = useLocation();
  const { id } = useParams();
  const [openHamburger, setOpenHamburger] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const [titlePage, setTitlePage] = useState("");
  const [textActive, setTextActive] = useState("");
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const { toggleTheme, theme, isMobile } = useContext(ContextProviderWrapper)!;
  const dispatch = useDispatch();
  const { kibPrice, listChains }: any = useSelector((state: any) => state.pool);
  const [listChain, setListChain] = useState([]);

  const handleChangeText = () => {
    switch (chain) {
      case "Solana":
        return "solana";
      case "Toncoin":
        return "ton";
      default:
        return "avax";
    }
  };

  const navData: any = [
    {
      id: 1,
      title: "Swap",
      href:
        chain === "Solana"
          ? `/swap/${handleChangeText()}`
          : `/swap/${handleChangeText()}`,
      delay: "0.1s",
      icon: iconSwap,
      light: iconSwap_light,
    },
    {
      id: 2,
      title: chain === "Solana" ? "" : "Liquidity",
      href: chain === "Solana" ? "" : `/liquidity/${handleChangeText()}`,
      delay: "0.2s",
      icon: iconLiquidity,
      light: iconLiquidity_light,
    },
    {
      id: 3,
      title: chain === "Solana" ? "" : "Launchpad",
      href: chain === "Solana" ? "" : `/launchpad/${handleChangeText()}`,
      delay: "0.3s",
      icon: iconLauch,
      light: iconLauch_light,
    },
    {
      id: 4,
      title: "Leaderboard",
      href: "/leaderboard",
      delay: "0.4s",
      icon: iconLauch,
      light: iconLauch_light,
    },
    {
      id: 5,
      title: chain === "Solana" ? "" : "Staking",
      href: chain === "Solana" ? "" : `/staking/${handleChangeText()}`,
      delay: "0.5s",
      icon: iconStaking,
      light: iconStaking_light,
    },
    {
      id: 6,
      title: "Bridge",
      href: "https://bridge.kibble.exchange/bridge",
      delay: chain === "Solana" ? "0.2s" : "0.6s",
      icon: "./static/Bridge.svg",
      light: iconStaking_light,
    },
    {
      id: 7,
      title: "DeFAI",
      href: "https://defai.kibble.exchange/",
      delay: chain === "Solana" ? "0.3s" : "0.7s",
      icon: "/static/defai_icon.svg",
      light: "/static/defai_icon.svg",
    },
  ];

  const navDataMobile: any = [
    {
      id: 1,
      title: "Swap",
      href:
        chain === "Solana"
          ? `/swap/${handleChangeText()}`
          : `/swap/${handleChangeText()}`,
      delay: "0.1s",
      icon: iconSwap,
      light: iconSwap_light,
    },
    {
      id: 2,
      title: chain === "Solana" ? "" : "Liquidity",
      href: chain === "Solana" ? "" : `/liquidity/${handleChangeText()}`,
      delay: "0.2s",
      icon: iconLiquidity,
      light: iconLiquidity_light,
    },
    {
      id: 3,
      title: chain === "Solana" ? "" : "Launchpad",
      href: chain === "Solana" ? "" : `/launchpad/${handleChangeText()}`,
      delay: "0.3s",
      icon: iconLauch,
      light: iconLauch_light,
    },
    {
      id: 4,
      title: chain === "Solana" ? "" : "Staking",
      href: chain === "Solana" ? "" : `/staking/${handleChangeText()}`,
      delay: "0.4s",
      icon: iconStaking,
      light: iconStaking_light,
    },
    {
      id: 5,
      title: "Leaderboard",
      href: "/leaderboard",
      delay: "0.5s",
      icon: "/static/leaderboard_icon.svg",
      light: "/static/leaderboard_icon.svg",
    },
    {
      id: 6,
      title: "Bridge",
      href: "https://bridge.kibble.exchange/bridge",
      delay: "0.6s",
      icon: "/static/Bridge.svg",
      light: "/static/Bridge.svg",
    },
    {
      id: 7,
      title: "DeFAI",
      href: "https://defai.kibble.exchange/",
      delay: "0.7s",
      icon: "/static/defai_icon.svg",
      light: "/static/defai_icon.svg",
    },
  ];

  const handleGetListChain = async () => {
    try {
      const { data } = await AVAX_API.listChain();
      setListChain(data);
      const chainActive = data?.find((item: any) => item.name === chain);
      const listAggregatorsActive = chainActive?.aggregators || [];
      dispatch(getChains(data));
      dispatch(getAggregators(listAggregatorsActive));
    } catch (error) {
      console.log("handleGetListChain err", error);
    }
  };

  useEffect(() => {
    handleGetListChain();
  }, [chain]);

  useEffect(() => {
    dispatch(getKIBPrice());
    const intervalId = setInterval(() => {
      dispatch(getKIBPrice());
    }, 10000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (openHamburger) {
      document.body.classList.add("hidden");
    } else {
      document.body.classList.remove("hidden");
    }
  }, [openHamburger]);

  const handleSetRouteName = async () => {
    if (matchPath("/liquidity/avax/details/:id", pathname)) {
      setTitlePage("liquidity/details");
    } else {
      const textInRoute = pathname
        .replaceAll("/avax/", " ")
        .split(" ")
        .filter((item: any) => item !== id && item);

      const title = `${
        textInRoute[0] ? textInRoute[0]?.split("/")[0] || "" : ""
      }`;

      setTextActive(textInRoute[0]);

      setTitlePage(title);
    }
  };

  useEffect(() => {
    handleSetRouteName();
  }, [pathname]);

  const hamburgerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        hamburgerRef.current &&
        !hamburgerRef.current.contains(event.target)
      ) {
        setCollapse(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [hamburgerRef]);

  useEffect(() => {
    dispatch(getActiveChain(chain));
  }, []);

  return (
    <>
      <HeaderDashboardContainer
        style={{
          backgroundColor:
            pathname === "/kibble" && theme === "dark"
              ? "#000"
              : pathname === "/kibble" && theme === "light"
              ? "#0375E9"
              : "",
        }}
      >
        <ModalOverlay
          component={
            <WalletInfo
              chain={chain}
              listChains={listChains}
              onCloseModal={() => {
                setOpenConfirmModal(false);
              }}
            />
          }
          onClickParent={() => {
            setOpenConfirmModal(false);
          }}
          open={openConfirmModal}
          setOpen={setOpenConfirmModal}
          title={"Your wallet"}
          width="500px"
          top={isMobile ? "40%" : ""}
        />
        <HeaderDashboardWrapper>
          <HDLogo to="https://kibble.exchange/">
            <img
              src={theme === "light" ? header_logo : header_logo}
              alt="logo"
            />
          </HDLogo>
          <HeaderAction>
            {kibPrice && !isMobile && (
              <PriceToken className={theme}>
                <figure>
                  <img src="../../assets/images/iconKIB.png" alt="icon" />
                </figure>
                <p
                  style={{
                    minWidth: "unset",
                  }}
                >
                  ${kibPrice || 0.0}
                </p>
              </PriceToken>
            )}
            <ActionTheme
              className={theme}
              onClick={() => {
                pathname !== "/kibble"
                  ? toggleTheme()
                  : toast.error("This page doesn't support light mode");
              }}
            />
            {listChains.length > 0 && (
              <ActionSocial className={theme}>
                <li
                  style={{
                    pointerEvents: "none",
                  }}
                >
                  <img
                    src={
                      listChains?.find((item: any) => item.name === chain)
                        ?.logoUrl
                    }
                    alt="icon"
                  />
                  {!isMobile && (
                    <p
                      style={{
                        color: theme === "dark" ? "#fff" : "#000",
                      }}
                    >
                      {listChains
                        ?.find((item: any) => item.name === chain)
                        ?.name.replace("Avalanche", "Avax")}
                    </p>
                  )}
                </li>
                {/* Popup switch chain */}
                <SwitchChain listChain={listChain} chainRouter={chain} />
                {/* ------------------ */}
              </ActionSocial>
            )}
            <ConnectWallet
              setOpenConfirmModal={setOpenConfirmModal}
              chain={chain}
            />
          </HeaderAction>
          <HeaderNavigation className={theme}>
            <p className="title-page">{titlePage}</p>
            <NavigationHamburger
              ref={hamburgerRef}
              onClick={() => {
                setCollapse(!collapse);
              }}
              className={
                collapse && theme === "dark"
                  ? "open"
                  : collapse && theme === "light"
                  ? `open ${theme}`
                  : theme
              }
              height={chain === "Solana" ? "174px" : "333px"}
              logoPosition={chain === "Solana" ? "-125px" : "-280px"}
            >
              <div>
                <span></span>
                <span></span>
              </div>
              <ul>
                {navData.map((item: any, index: number) => {
                  return (
                    <li
                      style={{
                        transform: collapse
                          ? "translate(0)"
                          : "translate(-30px)",
                        opacity: collapse ? "1" : "0",
                        transition: collapse ? "all .15s linear" : "none",
                        transitionDelay: collapse ? item.delay : "unset",
                        display: "block",
                      }}
                      onClick={() => {
                        setOpenHamburger(false);
                      }}
                      key={index}
                    >
                      <NavLink to={item.href}>
                        <p>{item.title}</p>
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            </NavigationHamburger>
          </HeaderNavigation>
          <NavigationMobileMain id="footer-mb">
            <NavigationMobile className={theme}>
              {navDataMobile.map((item: any, index: number) => {
                return (
                  <Link to={item.href} key={index}>
                    <NavigationMobileItem className={theme}>
                      <div className="img-icon">
                        <figure>
                          <img
                            style={{
                              filter:
                                `/${textActive}` === item.href
                                  ? "unset"
                                  : " contrast(0.1)",
                            }}
                            src={
                              `/${textActive}` === item.href &&
                              theme === "light"
                                ? item.light
                                : theme === "light"
                                ? item.light
                                : item.icon
                            }
                            alt={item.title}
                          />
                        </figure>
                      </div>
                    </NavigationMobileItem>
                  </Link>
                );
              })}
            </NavigationMobile>
          </NavigationMobileMain>
        </HeaderDashboardWrapper>
      </HeaderDashboardContainer>
      <NotificationHead />
    </>
  );
};

export default HeaderDashboard;
